import TEMPLATE_URL from "emun.invoice/parcel-picker/parcel-picker.htm";
import controller from "emun.invoice/parcel-picker/parcel-picker.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "lg",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  title = "Select parcel(s)...",
  subTitle = "Add to parcel list",
  view = "table",
  single = false,
  selected = {},
  criteria = {},
  onToggle = NOOP,
  onParcelSelected = NOOP,
  onParcelDeselected = NOOP,
  orderNumber,
  invoiceNumber,
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      subTitle: () => subTitle,
      orderNumber: () => orderNumber,
      options: () => ({
        title,
        subTitle,
        onParcelSelected,
        onParcelDeselected,
        onToggle,
        criteria,
        view,
        single,
        orderNumber,
        invoiceNumber,
        selected
      })
    }
  }).result;
